// extracted by mini-css-extract-plugin
export default {"kit-part-card__total-price-heading":"kit-part-card__total-price-heading_YLqfPEfU","kit-part-card__total-price-container":"kit-part-card__total-price-container_dFvOUZZy"};